export enum DropPositions {
  top = 'TOP',
  bottom = 'BOTTOM'
}
